<template>
  <div class="add-module-container">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        :title="items.title"
        :name="index + 1"
        v-for="(items, index) in componentsLib"
        :key="index"
      >
        <div class="componList" v-for="(item, ind) in items.comList" :key="ind" @click="handleClick(item,index,ind)">
          <i class="iconfont" :class="item.icon" v-if="item.icon" />
          <van-icon :name="item.icon" v-else />
          <p>{{ item.text }}</p>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "AddModule",
  props: {
    datas: Object,
  },
  data() {
    return {
      activeNames: [1, 2, 3] /* 侧边栏组件显示 */,
      componentsLib: [
        {
          title: "常用",
          comList: [
            {
              text: "标题文本",
              type: "1-1",
              icon: "icon-Component-biaotiwenzi",
              name: "captiontext",
            },
            {
              text: "商品搜索",
              type: "1-2",
              icon: "icon-shangpinsousuo",
              name: "commoditysearch",
            },

            {
              text: "标题栏",
              type: "1-3",
              icon: "icon-tupianguanggao",
              name: "titlebar",
            },
            {
              text: "图片广告",
              type: "1-4",
              icon: "icon-tupianguanggao",
              name: "pictureads",
            },
            // {
            //   text: "图片+导航组",
            //   type: "1-5",
            //   icon: "icon-tupianguanggao",
            //   name: "picturenavgroup",
            // },
            // {
            //   text: "图文导航",
            //   type: "1-6",
            //   icon: "icon-icon_tupiandaohang",
            //   name: "graphicnavigation",
            // },
            {
              text: "服务导航",
              type: "1-7",
              icon: "icon-tupianguanggao",
              name: "servicenavigation",
            },
            {
              text: "公告",
              type: "1-8",
              icon: "icon-gonggao",
              name: "notice",
            },
          ],
        },
        {
          title: "基础",
          comList: [
            {
              text: "文章列表",
              type: "3-1",
              icon: "icon-Component-biaotiwenzi",
              name: "storenotecard",
            },
          ],
        },
        {
          title: "互动",
          comList: [
            {
              text: "互动卡片",
              type: "4-1",
              icon: "icon-Component-biaotiwenzi",
              name: "interactioncard",
            },
          ],
        },
      ],
    };
  },
  created() { },
  methods: {
    handleClick(item,index,ind) {
      console.log(item, index, ind);
      this.$emit("handleClick", { 
        item: item,
        index: index,
        ind: ind,
       });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-module-container {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 5px;
  /* 组件列表 */
  .componList {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    width: 80px;
    height: 88px;
    margin-bottom: 8px;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      background: #348cf8;
      border-radius: 2px;
      font-weight: 700;
      i,
      p,
      span {
        color: #fff;
      }
    }
    /* 图标 */
    i {
      font-size: 32px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      color: #b0a8a8;
      margin-top: 4px;
    }
    /* 标题 */
    p {
      font-size: 12px;
      color: #323233;
      margin-top: 4px;
    }
    /* 数量 */
    span {
      color: #7d7e80;
      margin-top: 4px;
      font-size: 10px;
    }
  }
}
</style>
